export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    $('.h-header-slides').slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 9000,
    });
        
    $(".header-slides-control--next").on("click", function() {
      $(".h-header-slides").slick("slickNext")
    });
          
    $(".header-slides-control--prev").on("click", function() {
      $(".h-header-slides").slick("slickPrev")
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js